{
  "collect": {
    "welcome": {
      "header": "MISE \u00c0 JOUR DES COMP\u00c9TENCES EN IA",
      "is-this-you": "Est-ce bien vous ?"
    },
    "intro": {
      "header": "Parlez-nous de vos r\u00e9alisations en IA.",
      "header-subtext": "Cela nous aide \u00e0 vous mettre en relation avec les bonnes opportunit\u00e9s et \u00e0 vous pr\u00e9senter aux clients qui recherchent vos comp\u00e9tences en IA."
    },
    "profile-header": {
      "profile-updated": "Votre profil Aquent sera mis \u00e0 jour.",
      "not-you": "Pas vous ?",
      "logout": "Se d\u00e9connecter",
      "open-my-aquent": "Ouvrez MyAquent"
    },
    "ai-tools": {
      "header": "Quels outils ou comp\u00e9tences en IA ma\u00eetrisez-vous? *",
      "label": "Outils d'IA",
      "placeholder": "ex. Cursor, Motion, DALL-E, Midjourney...",
      "hint": "Appuyez sur Entrer pour ajouter chaque outil/comp\u00e9tence.",
      "remove-aria": "supprimer {{skill}}"
    },
    "stories": {
      "header": "Partager une r\u00e9ussite avec IA",
      "header-optional": "(facultatif)",
      "header-subtext": "D\u00e9crivez un projet dont vous \u00eates particuli\u00e8rement fier.",
      "organization": "Organisation ou contexte de cette r\u00e9alisation",
      "organization-placeholder": "Pour qui \u00e9tait-ce?",
      "date": "Date",
      "date-placeholder": "Quand est-ce arriv\u00e9, approximativement?",
      "problem": "Quel probl\u00e8me r\u00e9solviez-vous?",
      "problem-placeholder": "Qu'est-ce qui ne fonctionnait pas, manquait ou \u00e9tait frustrant avant votre intervention?",
      "action": "Comment avez-vous utilis\u00e9 l'IA?",
      "action-placeholder": "Quels outils avez-vous utilis\u00e9s, et qu'avez-vous fait concr\u00e8tement avec ces outils? Soyez pr\u00e9cis \u2014 c\u2019est le c\u0153ur du sujet.",
      "result": "Quel a \u00e9t\u00e9 l'impact?",
      "result-placeholder": "Qu'est-ce qui a \u00e9t\u00e9 am\u00e9lior\u00e9? Les chiffres sont excellents, mais un \u00ab avant et apr\u00e8s \u00bb clair fonctionne aussi.",
      "add": "Ajouter une r\u00e9ussite",
      "remove-aria": "Supprimer la r\u00e9ussite"
    },
    "save": "Enregistrer dans le profil",
    "thank-you": {
      "header-confirmed-identity": "Merci d'avoir partag\u00e9 votre exp\u00e9rience.",
      "header-confirmed-identity-subtext": "Pensez \u00e0 maintenir votre CV et vos parcours \u00e0 jour au fur et \u00e0 mesure de vos r\u00e9ussites.",
      "header-not-confirmed-identity": "Merci de nous en avoir inform\u00e9s.",
      "add-more-tools": "Nous vous proposerons des opportunit\u00e9s dans l'IA correspondant \u00e0 votre profil.",
      "update-skills": "Pour mettre \u00e0 jour vos comp\u00e9tences en IA, connectez-vous \u00e0 votre compte MyAquent.",
      "view-my-profile": "Voir mon profil",
      "open-my-aquent": "Ouvrez MyAquent"
    }
  },
  "portfolio-collect": {
    "page-title": "Ajoutez votre portfolio \u00e0 Milton | Aquent",
    "header": "Ajoutez votre portfolio \u00e0 Milton.",
    "lead": "Milton recherche dans les r\u00e9alisations visuelles de votre portfolio. Partager l\u2019url de votre portfolio peut nous aider \u00e0 vous proposer des opportunit\u00e9s ouvertes.",
    "what-is-milton": "Qu\u2019est-ce que Milton, et qu\u2019advient-il de mon travail ?",
    "what-is-milton-body-1": "Milton est notre outil propri\u00e9taire de recherche visuelle. Il examine les images de votre portfolio plut\u00f4t que les mots de votre CV.",
    "what-is-milton-body-2": "Autrement dit, vous pouvez \u00eatre identifi\u00e9 pour une opportunit\u00e9 gr\u00e2ce \u00e0 ce que vous avez r\u00e9ellement cr\u00e9\u00e9, et non parce que votre intitul\u00e9 de poste correspondait.",
    "what-is-milton-body-3": "Le seul r\u00f4le de Milton est la mise en relation. Il lit les images d\u2019un portfolio pour que nous puissions trouver la bonne personne pour un brief, rien de plus.",
    "url": {
      "label": "Le lien de votre portfolio",
      "placeholder": "Collez le lien de votre portfolio",
      "hint": "Votre propre site est id\u00e9al, sinon Behance, Dribbble, ArtStation. Pas LinkedIn ni un CV.",
      "error-missing": "Ajoutez un lien avant d\u2019enregistrer.",
      "error-invalid": "Cela ne ressemble pas \u00e0 une adresse web. V\u00e9rifiez-la et r\u00e9essayez.",
      "error-save-failed": "Impossible d\u2019enregistrer votre lien pour le moment."
    },
    "password": {
      "toggle": "Ce site n\u00e9cessite un mot de passe",
      "label": "Mot de passe",
      "placeholder": "Mot de passe de ce site",
      "note": "Nous l\u2019utiliserons uniquement pour que Milton puisse voir votre travail.",
      "show-aria": "Afficher le mot de passe",
      "hide-aria": "Masquer le mot de passe"
    },
    "submit": "Ajouter mon portfolio",
    "reassurance-lead": "Milton est un outil interne \u00e0 Aquent.",
    "reassurance": "Nous n\u2019entra\u00eenons pas d\u2019IA sur votre travail.",
    "no-portfolio": {
      "header": "Je n\u2019ai pas de portfolio",
      "body": "Pas de probl\u00e8me. Milton ne recherche que des portfolios visuels, mais nos recruteurs utilisent d\u2019autres ressources comme LinkedIn et GitHub pour vous proposer des opportunit\u00e9s ouvertes.",
      "link": "Mettre \u00e0 jour mes urls dans MyAquent"
    },
    "not-you": "Ce n\u2019est pas vous ?",
    "sign-in": "Connectez-vous \u00e0 MyAquent",
    "thank-you": {
      "header": "Merci, votre portfolio sera pris en compte pour les opportunit\u00e9s ouvertes.",
      "body": "Vous avez autre chose \u00e0 nous montrer, un autre portfolio, un LinkedIn, un GitHub, une d\u00e9mo ? Vous pouvez mettre \u00e0 jour toutes vos urls \u00e0 tout moment depuis votre profil.",
      "cta": "Se connecter \u00e0 MyAquent"
    }
  },
  "currency-symbol": "\u20ac",
  "data-refresh": {
    "availability": {
      "label": "Quand \u00eates-vous disponible pour commencer ?",
      "now": "Disponible d\u00e8s maintenant",
      "specific-date": "Disponible \u00e0 une date pr\u00e9cise",
      "specific-date-placeholder": "Date de disponibilit\u00e9",
      "with-notice": "Disponible avec pr\u00e9avis",
      "with-notice-placeholder": "Entrez le nombre de mois de pr\u00e9avis"
    },
    "check-in": "Quand pouvons-nous reprendre contact avec vous ?",
    "employment-type": {
      "label": "Type de contrat",
      "temp": "Int\u00e9rim",
      "temp-to-perm": "Temp-to-perm",
      "perm": "CDI",
      "error": "Veuillez s\u00e9lectionner au moins une option : CDI, int\u00e9rim ou Temp-to-perm"
    },
    "error": {
      "required": "{{fieldName}} est un champ obligatoire",
      "at-least-one": "Au moins une option doit \u00eatre s\u00e9lectionn\u00e9e",
      "at-least-one-groups": "Au moins une option de chaque groupe doit \u00eatre s\u00e9lectionn\u00e9e"
    },
    "header": {
      "text": "Mettez \u00e0 jour vos pr\u00e9f\u00e9rences professionnelles",
      "subtext-required": "Tous les champs sont obligatoires"
    },
    "hourly-rate": {
      "label": "Taux horaire{{required}}",
      "target": "Pr\u00e9tentions salariales  en brut",
      "minimum": "Minimum",
      "per-hour": "/heure",
      "error-minimum": "Veuillez entrer une valeur pour le taux horaire minimum",
      "error-target": "Veuillez entrer une valeur pour le taux horaire souhait\u00e9",
      "error-both": "Veuillez entrer une valeur pour le taux horaire minimum et souhait\u00e9"
    },
    "hours": {
      "label": "Heures",
      "full-time": "Temps plein",
      "part-time": "Temps partiel",
      "error": "Veuillez s\u00e9lectionner au moins une option : temps plein ou temps partiel"
    },
    "last-updated": "Derni\u00e8re mise \u00e0 jour le {{lastUpdated}}",
    "location": "O\u00f9 \u00eates-vous situ\u00e9 ?",
    "opportunities": "Envisagez-vous de nouvelles opportunit\u00e9s ?",
    "read-only": {
      "header": "Le timing est essentiel",
      "subtext": "C'est le moment id\u00e9al pour vous pr\u00e9senter de super offres d'emploi ! Mais avant tout, veuillez confirmer que les informations suivantes sont correctes\u00a0:",
      "minimum-hourly": "Taux horaire minimum :",
      "target-hourly": "Taux horaire souhait\u00e9 :",
      "minimum-salary": "Salaire minimum :",
      "target-salary": "Salaire souhait\u00e9 :",
      "preferred-work-type": "Type de contrat privil\u00e9gi\u00e9 :",
      "preferred-hours": "Horaires pr\u00e9f\u00e9r\u00e9s :",
      "preferred-workplace": "Lieu de travail souhait\u00e9 :",
      "looks-good": "Valider",
      "edit": "Modifier"
    },
    "salary": {
      "label": "Salaire annuel brut {{required}}",
      "target": "Pr\u00e9tentions salariales  en brut",
      "minimum": "Minimum brut",
      "per-year": "/an",
      "error-minimum": "Veuillez entrer une valeur pour le salaire minimum",
      "error-target": "Veuillez entrer une valeur pour le salaire souhait\u00e9",
      "error-both": "Veuillez entrer une valeur pour le salaire minimum et souhait\u00e9"
    },
    "submit-go-ahead": {
      "label": "Pouvons-nous pr\u00e9senter votre profil \u00e0 nos clients pour des postes correspondant \u00e0 vos pr\u00e9f\u00e9rences ci-dessous ?",
      "yes": "Oui, allez-y.",
      "no": "Non, veuillez me consulter d'abord."
    },
    "success-page": {
      "heading": "MERCI DE NOUS AVOIR FAIT PART DE VOS OBJECTIFS DE CARRI\u00c8RE !",
      "update-profile-desc": "N'h\u00e9sitez pas \u00e0 nous faire parvenir une version actualis\u00e9e de votre CV ou portfolio si vous avez acquis de nouvelles comp\u00e9tences depuis notre dernier \u00e9change.",
      "find-jobs-desc": "Trouvez plus d'offres d'emploi sur le site d'Aquent."
    },
    "workplace": {
      "label": "Lieu de travail*",
      "on-site": "Sur site",
      "remote": "T\u00e9l\u00e9travail",
      "error": "Veuillez s\u00e9lectionner au moins une option : sur site ou t\u00e9l\u00e9travail"
    }
  },
  "eeoc-form": {
    "success-find-jobs": "Trouver un emploi",
    "success-find-jobs-info": "Trouver d'autres offres d'emploi",
    "success-learn-more": "En savoir plus",
    "success-learn-more-info": "En savoir plus sur nos initiatives en mati\u00e8re de diversit\u00e9 et d'inclusion",
    "success-update-profile": "Mettre \u00e0 jour votre profil ",
    "success-update-profile-info": "Mettre \u00e0 jour votre profil Aquent"
  },
  "footer": {
    "application-support": "Support pour l'adaptation des candidatures",
    "copyright-aq": "\u00a9 {{year}} Aquent",
    "privacy-policy": "Politique de confidentialit\u00e9",
    "logout": "Se d\u00e9connecter",
    "logout-confirmation": "\u00cates-vous s\u00fbr de vouloir vous d\u00e9connecter ?",
    "questions-email": "questions@aquent.com"
  },
  "talent-availability": {
    "error": {
      "header": "Une erreur s'est produite",
      "body": "Nous n'avons pas pu traiter votre demande. Veuillez r\u00e9essayer plus tard."
    },
    "unsubscribe-success": {
      "header": "D'accord, aucun probl\u00e8me",
      "no-more-job-notifications": "Vous avez bien \u00e9t\u00e9 d\u00e9sabonn\u00e9(e). Nous ne vous enverrons plus d'e-mails d'alerte d'offres d'emploi. Vous pouvez mettre \u00e0 jour votre disponibilit\u00e9 \u00e0 tout moment dans MyAquent.",
      "did-not-meant-to-unsubscribe": "Attendez, je ne voulais pas me d\u00e9sabonner !"
    },
    "subscribe-success": {
      "header": "Excellente nouvelle !",
      "notifications-back": "Parfait, vous pouvez d\u00e9sormais recevoir les e-mails d'alerte d'offres d'emploi. Vous pouvez mettre \u00e0 jour votre disponibilit\u00e9 \u00e0 tout moment dans MyAquent.",
      "go-to-myaquent": "Acc\u00e9der \u00e0 MyAquent"
    }
  },
  "web-style-top-bar": {
    "preferences-confirmed": "Confirmer mes pr\u00e9f\u00e9rences",
    "preferences-edit": "Modifier mes pr\u00e9f\u00e9rences"
  },
  "redeploy": {
    "preferences-edit-header": "Modifiez vos pr\u00e9f\u00e9rences professionnelles",
    "take-a-moment": "Prenez un moment pour modifier vos pr\u00e9f\u00e9rences, si elles ne sont plus \u00e0 jour, pour que nous ayons les bonnes informations",
    "phone": "T\u00e9l\u00e9phone",
    "location": "Localisation",
    "available-to-start": "Disponible pour commencer",
    "weeks-notice": "Pr\u00e9avis en mois",
    "employment-type-label": "Type de contrat",
    "workplace-label": "Lieu de travail",
    "hourly-rate-label": "Taux horaire",
    "salary-label": "Salaire annuel",
    "permission-to-submit": "Pouvons-nous vous pr\u00e9senter \u00e0 des clients correspondant \u00e0 ces pr\u00e9f\u00e9rences ?",
    "resume-header": "CV",
    "current-resume": "CV actuel",
    "uploaded-on": "Soumis le ",
    "upload-resume": "Soumettre un nouveau CV",
    "cancel": "Annuler"
  },
  "thank-you": "Merci. Vous \u00eates pr\u00eat(e) !",
  "no": "Non",
  "submit": "Soumettre",
  "delete": "Supprimer",
  "yes": "Oui",
  "gather": {
    "complete-profile": "Compl\u00e9tez votre profil",
    "eeoc-form-title": "\u00c9galit\u00e9 des chances",
    "enter-url": "Entrez une URL",
    "error": {
      "general": "Hmm... nous rencontrons des probl\u00e8mes avec cette URL. Veuillez v\u00e9rifier qu'elle est correcte avant de continuer.",
      "inaccessible": "Hmm... nous avons des difficult\u00e9s \u00e0 acc\u00e9der \u00e0 votre site. Veuillez v\u00e9rifier que votre URL est correcte avant de continuer.",
      "not-found": "Hmm... nous avons des difficult\u00e9s \u00e0 trouver votre site. Veuillez v\u00e9rifier que votre URL est correcte avant de continuer."
    },
    "apply": "POSTULEZ MAINTENANT",
    "not-a-fit": "PAS INT\u00c9RESS\u00c9",
    "interested": {
      "label": "INT\u00c9RESS\u00c9(E)",
      "title": "Mettre \u00e0 jour votre disponibilit\u00e9",
      "confirm": {
        "title": "Merci !"
      },
      "compensation": "Quelle est votre r\u00e9mun\u00e9ration brute id\u00e9ale ?",
      "compensation-and-availability": "R\u00e9mun\u00e9ration et disponibilit\u00e9",
      "availability": "Disponibilit\u00e9",
      "desired-pay": "R\u00e9mun\u00e9ration brute souhait\u00e9e",
      "available-to-start": "Quand seriez-vous disponible pour commencer ?",
      "enter-annual-salary": "Entrez le salaire annuel brut",
      "enter-hourly-rate": "Entrez le taux horaire brute",
      "enter-total-compensation": "Entrez la r\u00e9mun\u00e9ration brute totale ",
      "optional": "(Optionnel)",
      "professional-profile": "Profil professionnel",
      "immediately": "Imm\u00e9diatement",
      "non-integer-number-of-weeks-error": "Veuillez entrer une valeur enti\u00e8re non nulle pour le nombre de mois de pr\u00e9avis"
    },
    "interest": {
      "title": "Int\u00e9r\u00eat pour le poste"
    },
    "notice-text": "Combien de mois de pr\u00e9avis ?",
    "immediately": "Imm\u00e9diatement",
    "with-notice": "Avec pr\u00e9avis",
    "two-weeks-notice": "Pr\u00e9avis d'un mois",
    "specific-date": "\u00c0 une date sp\u00e9cifique",
    "thank-you": "Merci !",
    "thank-you-text": "Votre int\u00e9r\u00eat et votre disponibilit\u00e9 ont \u00e9t\u00e9 envoy\u00e9s au recruteur en charge de ce poste. Il/Elle les examinera et vous contactera si vous correspondez au profil recherch\u00e9.",
    "second-time": {
      "thank-you-text": "Nous avons re\u00e7u votre r\u00e9ponse le {{responseDate}}. Si vous avez des questions, veuillez contacter {{agentName}} \u00e0 {{agentEmail}}."
    },
    "loading-text": "Un instant...",
    "update-profile": "Mettre \u00e0 jour le profil",
    "update-profile-text": "Nouveau CV ou portfolio ? Mettez \u00e0 jour vos informations afin que les recruteurs et les clients voient vos derniers projets ",
    "update-my-profile": "Mettre \u00e0 jour mon profil",
    "complete-review-text": "Demandez des avis \u00e0 vos anciens coll\u00e8gues pour mettre en valeur vos forces, comp\u00e9tences et potentiel.",
    "add-reviews": "SOUMETTRE DES AVIS",
    "track-your-status": "Suivez l'\u00e9volution de votre candidature",
    "track-status-text": "Consultez votre statut pour les postes que vous envisagez. Nous vous contacterons pour toute mise \u00e0 jour urgente.",
    "track-my-status": "Suivez l'\u00e9volution de votre candidature",
    "see-more-jobs": "Voir plus d'offres",
    "see-more-jobs-text": "Nous travaillons sur de nouveaux postes chaque jour ! D\u00e9couvrez d'autres annonces qui pourraient vous int\u00e9resser ",
    "visit-job-center": "Visitez notre page d'offres d'emploi",
    "description": "DESCRIPTION",
    "showcase": "Montrez-nous ce que vous savez faire de mieux",
    "starting": "\u00c0 partir du",
    "full-time": "TEMPS PLEIN",
    "part-time": "TEMPS PARTIEL",
    "jobId": "ID de l'offre #",
    "agent": "Recruteur :",
    "availability": {
      "next": "Suivant",
      "confirm": "Confirmer",
      "submit": "Soumettre",
      "response-date": "jj mm aaaa",
      "error": "Un probl\u00e8me est survenu lors de l'enregistrement de vos disponibilit\u00e9s. Merci de r\u00e9essayer."
    },
    "client-description": "DESCRIPTION DU CLIENT",
    "other-requirements": "AUTRES PR\u00c9REQUIS",
    "not-interested": {
      "actively-looking": "Recherche active",
      "available-to-start": "Quand serez-vous disponible pour commencer ?",
      "be-in-touch": "Super ! Nous allons vous contacter.",
      "check-in-again": "Quand devrions-nous reprendre contact ?",
      "hear-from-us": "Souhaitez-vous que nous vous contactions si nous avons une super opportunit\u00e9 ?",
      "job-search": "O\u00f9 en \u00eates-vous dans votre recherche d'emploi ?",
      "label": "Non merci",
      "title": "Pas int\u00e9ress\u00e9(e)",
      "check-back-few-months": "Recontactez-moi dans quelques mois",
      "check-back-on": "Recontactez-moi \u00e0 une date sp\u00e9cifique",
      "company-or-industry": "Entreprise ou secteur",
      "choose-a-date": "Choisissez une date",
      "pay-rate": "Taux horaire brut",
      "location": "Localisation",
      "skill-set": "Comp\u00e9tences incompatibles",
      "other": "Autre",
      "tell-us-more": "Dites-nous en plus :",
      "tell-us-more-interested": "Notes suppl\u00e9mentaires \u00e0 nous partager ?",
      "primary-reason": "Pouvez-vous nous indiquer la ou les raisons pour lesquelles cette offre ne vous convient pas ? ",
      "send-feedback": "Partagez votre exp\u00e9rience",
      "submit": "Soumettre",
      "thank-you-text": "Nous avons re\u00e7u vos retours et les utiliserons pour am\u00e9liorer nos notifications.",
      "refer-friend": "Recommandez un ami",
      "learn-more": "En savoir plus",
      "confirm": {
        "title": "Merci !"
      },
      "reason": {
        "skill-set-mismatch": "Comp\u00e9tences incompatibles",
        "level-mismatch": "Niveau incompatible",
        "pay-rate": "Taux horaire",
        "location": "Localisation",
        "industry": "Secteur",
        "other": "Autre"
      },
      "refer-text": "Vous connaissez quelqu'un qui serait parfait pour ce poste ? Faites-le nous savoir ! D\u00e9couvrez les d\u00e9tails de notre programme de compensations.",
      "still-interested": "\u00cates-vous toujours int\u00e9ress\u00e9(e) par d'autres opportunit\u00e9s ?",
      "still-interested-confirmation": "Quand seriez-vous disponible pour commencer une nouvelle opportunit\u00e9 ?",
      "thank-you": "Merci pour votre r\u00e9ponse",
      "may-we-check-in": "Faites-nous savoir quand nous pourrons reprendre contact.",
      "not-currently-looking": "Pas en recherche active",
      "open-to-opportunities": "Ouvert(e) aux bonnes opportunit\u00e9s",
      "other-job-postings": "Il y a plein d'autres offres disponibles sur notre page d'offres d'emploi. Jetez-y un \u0153il !"
    },
    "back-to-posting": "< Retour \u00e0 l'annonce",
    "not-interested-text": "Veuillez nous dire pourquoi ce poste ne vous int\u00e9ressait pas afin que nous puissions am\u00e9liorer nos notifications.",
    "yes": "Oui",
    "no": "Non",
    "job-closed": {
      "sorry": "Nous sommes d\u00e9sol\u00e9s",
      "sorry-text": "Nous vous remercions de votre int\u00e9r\u00eat, mais cette offre d'emploi n'est malheureusement plus disponible."
    },
    "invalid-id": {
      "text": "Nous sommes d\u00e9sol\u00e9s, mais la page que vous recherchez semble introuvable.",
      "oops": "Oups !"
    },
    "already-a-talent": {
      "text": "Il semble que vous travaillez d\u00e9j\u00e0 avec nous sur cette opportunit\u00e9. Veuillez contacter votre recruteur pour toute question :",
      "oops": "Oups !"
    },
    "thank-you-page": {
      "title": "Merci !",
      "message": "Vos r\u00e9ponses ont \u00e9t\u00e9 envoy\u00e9es. Pour explorer plus d'offres d'emploi, allez sur myAquent.com",
      "button": "Allez sur MyAquent"
    },
    "greetings": "Bonjour",
    "header1": "Voici une nouvelle offre sur laquelle nous travaillons qui correspond \u00e0 vos pr\u00e9f\u00e9rences",
    "header2": "sur dossier. Veuillez examiner les d\u00e9tails et nous faire savoir si vous \u00eates int\u00e9ress\u00e9(e) ci-dessous.",
    "footer-address": "40 rue du Louvre, 75001, Paris",
    "privacy-policy": "Il ne s'agit pas d'un message marketing. Ce message a pour but de vous communiquer des informations importantes concernant votre activit\u00e9 avec Aquent.",
    "privacy": "Confidentialit\u00e9",
    "resume": {
      "update": "Si vous avez un CV mis \u00e0 jour, vous pouvez l'inclure ici :",
      "last-updated": "Derni\u00e8re mise \u00e0 jour {{latestResumeDate}}",
      "upload-a-new-resume": "Soumettre un nouveau CV mettra \u00e0 jour vos \u00e9tudes, vos comp\u00e9tences et votre exp\u00e9rience sur MyAquent",
      "upload": "Ajouter un fichier",
      "none": "Aucun fichier s\u00e9lectionn\u00e9"
    },
    "titles": {
      "role-interest": "Int\u00e9r\u00eat pour le r\u00f4le"
    }
  },
  "double-opt-in": {
    "confirm": {
      "header": "Merci et bienvenue !",
      "sub-text": "Vous \u00eates abonn\u00e9(e) avec succ\u00e8s \u00e0 la Newsletter Aquent."
    }
  },
  "pre-interview-questions": {
    "category": {
      "authorization": "autorisation",
      "location": "localisation",
      "relocation": "d\u00e9m\u00e9nagement",
      "travel": "voyage"
    },
    "question": {
      "0": "\u00cates-vous autoris\u00e9(e) \u00e0 travailler en France ?",
      "1": "Avez-vous besoin d'un visa de travail actuellement ou \u00e0 l'avenir ?",
      "2": "\u00cates-vous situ\u00e9(e) en France ?",
      "3": "Pouvez-vous travailler sur site chez le client ?",
      "4": "Combien de jours par semaine pouvez-vous travailler sur site ?",
      "5": "\u00cates-vous pr\u00eat(e) \u00e0 d\u00e9m\u00e9nager ?",
      "6": "\u00cates-vous pr\u00eat(e) \u00e0 d\u00e9m\u00e9nager \u00e0 vos propres frais ?",
      "7": "Combien de temps \u00eates-vous pr\u00eat(e) \u00e0 voyager pour ce poste ?"
    },
    "header": "Questions avant entretien",
    "header-description": "Il s'agit d'une fonctionnalit\u00e9 optionnelle pour poser des questions suppl\u00e9mentaires aux candidats dans le processus de candidature et de Gather. Vous avez la possibilit\u00e9 de s\u00e9lectionner jusqu'\u00e0 3 questions optionnelles.",
    "no-questions-selected-message": "Vous n'avez pas encore s\u00e9lectionn\u00e9 de questions. Cliquez sur le bouton de modification pour commencer ! \ud83d\ude42",
    "answer-options": "Options de r\u00e9ponse",
    "answer-option-yes": "Oui",
    "answer-option-no": "Non",
    "answer-header-description": "Veuillez r\u00e9pondre aux questions suivantes du mieux que vous pouvez. Les questions sont optionnelles.",
    "textarea-max-characters": "(limite de caract\u00e8res : 500)"
  },
  "talent-happy-path": {
    "general-application": {
      "header-overline-text": "Rejoignez notre",
      "header-text": "Communauté de talents"
    },
    "welcome-text": "Bienvenue sur MyAquent",
    "radio": {
      "yes": "Oui",
      "no": "Non",
      "check-later": "Me consulter plus tard",
      "other-option": "Autre"
    },
    "buttons": {
      "back": "Retour",
      "do-later": "Je m'en occuperai plus tard.",
      "finish": "Terminer",
      "lets-do-this": "C'est parti",
      "next": "Suivant",
      "submit": "Soumettre",
      "cancel": "Annuler",
      "ok": "D'accord",
      "yes": "Oui"
    },
    "labels": {
      "date": "Date"
    },
    "select-list": {
      "yes": "Oui",
      "no": "Non",
      "no-answer": "Je ne souhaite pas r\u00e9pondre",
      "please-select-text": "Veuillez s\u00e9lectionner"
    },
    "talent-profile": {
      "header": "Profil du talent",
      "authorization-page": {
        "title": "Autorisation",
        "location": "O\u00f9 \u00eates-vous situ\u00e9(e) ?",
        "authorized-in-location": "\u00cates vous autoris\u00e9(e) \u00e0 travailler dans le pays o\u00f9 le poste est propos\u00e9 ?",
        "sponsorship": "Avez-vous besoin, maintenant ou \u00e0 l'avenir, d'une autorisation de travail ?"
      },
      "preferences": {
        "title": "Vos pr\u00e9f\u00e9rences",
        "type": "Type de contrat ?",
        "work-hours": "Horaire de travail ?",
        "workplace": "Pr\u00e9f\u00e9rence de lieu de travail ?",
        "types": {
          "temp": "Int\u00e9rimaire/CDD",
          "temp-to-perm": "Temp-to-perm",
          "perm": "CDI",
          "full-time": "Temps plein",
          "part-time": "Temps partiel",
          "onsite": "Sur site",
          "remote": "\u00c0 distance",
          "hybrid": "Hybride"
        }
      },
      "opportunities": {
        "title": "Offres d'emploi",
        "new-opportunities": "\u00cates-vous ouvert(e) \u00e0 de nouvelles opportunit\u00e9s ?",
        "when-available": "Quelle est votre date de disponibilit\u00e9 ? ",
        "submit-other": "Souhaiteriez-vous que nous vous proposions d'autres postes en ad\u00e9quation avec votre profil ?",
        "availability-types": {
          "now": "Maintenant",
          "date": "Date pr\u00e9cise",
          "notice": "Avec pr\u00e9avis",
          "weeks-notice": "Pr\u00e9avis en mois"
        }
      },
      "salary": {
        "title": "Salaire Brut",
        "hourly-pay": "Salaire horaire brut",
        "desired-hourly": "Taux horaire brut souhait\u00e9",
        "minimum-hourly": "Taux horaire brut minimum",
        "salary-pay": "Salaire Brut",
        "desired-salary": "Salaire brut souhait\u00e9",
        "minimum-salary": "Salaire brut minimum",
        "salary-error": "Le salaire minimum ne peut pas \u00eatre sup\u00e9rieur au salaire souhait\u00e9.",
        "hourly-error": "Le salaire minimum ne peut pas \u00eatre sup\u00e9rieur au salaire souhait\u00e9."
      },
      "splash-page": {
        "content": "Pour que nous vous connaissions mieux, compl\u00e9tez votre profil",
        "complete-profile-button": "Cr\u00e9er mon profil"
      },
      "later-modal": {
        "header": "Compl\u00e9ter mon profil plus tard ?",
        "description": "Le cas \u00e9ch\u00e9ant, nous vous enverrons un lien par email pour poursuivre cette partie de la candidature."
      },
      "progress-bar-description": {
        "of": "de",
        "sections": "sections"
      },
      "file-upload": {
        "resume": "CV"
      }
    },
    "initial-interview-questions": {
      "header-overline-text": "Premi\u00e8res questions d'entretien",
      "initial-interview-question": "Premi\u00e8re Question d'entretien ",
      "progress-bar-text": "{{currentQuestionNumber}} sur {{totalQuestions}} questions",
      "progress-bar-text-loading": "{{currentQuestionNumber}} sur",
      "progress-bar-text-loading-end": "questions",
      "this-question-was-ai-generated": "Cette question a \u00e9t\u00e9 g\u00e9n\u00e9r\u00e9e gr\u00e2ce \u00e0 l'IA",
      "standard-question": "Dites-nous pourquoi vous seriez un bon candidat pour ce poste",
      "splash-page": {
        "check-for-questions": "V\u00e9rifions si nous avons des premi\u00e8res questions \u00e0 vous poser",
        "content-text-when-questions": "R\u00e9pondre aux premi\u00e8res questions",
        "content-text-when-no-questions": "Aucune question \u00e0 r\u00e9pondre",
        "heading-when-questions": "R\u00e9pondre aux questions initiales",
        "next-button-text": "Suivant",
        "next-button-text-lets-do-this": "C'est parti",
        "sub-heading-when-questions": "Compl\u00e9ter cette \u00e9tape peut vous aider \u00e0 vous d\u00e9marquer des autres candidats",
        "header-overline-text": "Merci d'avoir soumis votre candidature"
      },
      "application-submit-page": {
        "header": "Merci d'avoir soumis votre candidature !",
        "header-interest": "Merci de votre int\u00e9r\u00eat pour ce poste !",
        "sub-header": "R\u00e9pondre \u00e0 ces premi\u00e8res questions est une premi\u00e8re \u00e9tape cl\u00e9 pour vous d\u00e9marquer"
      },
      "no-questions-page": {
        "header": "C'est fini pour les questions",
        "sub-header": "Pour que nous vous connaissions mieux et que l'on vous propose de nouvelles opportunit\u00e9s appropri\u00e9es, soumettez votre r\u00e9ponse et passez \u00e0 l'\u00e9tape suivante"
      },
      "hang-tight-page": {
        "header": "Patientez ! Nous g\u00e9n\u00e9rons plus de questions pour vous aider \u00e0 vous d\u00e9marquer"
      }
    },
    "quick-apply": {
      "error" : {
        "invalid-location" : "Sélectionnez une localisation valide dans la liste des suggestions",
        "failed-to-get-location": "Impossible d'obtenir les informations de localisation. Veuillez réessayer."
      },
      "header-overline-text": "Postuler pour",
      "thank-you-page": {
        "title": "Merci pour votre candidature !",
        "message": "Nous vous contacterons si votre profil est retenu pour les prochaines \u00e9tapes du process. Pour aider nos recruteurs, veuillez vous connecter \u00e0 votre profil MyAquent o\u00f9 vous pourrez fournir des informations suppl\u00e9mentaires, configurer des alertes d'emploi et mettre \u00e0 jour votre disponibilit\u00e9.",
        "button": "Aller sur MyAquent"
      },
      "welcome-page": {
        "title": "Ravi de vous revoir,",
        "continue-message": "Reprenons l\u00e0 o\u00f9 vous vous \u00e9tiez arr\u00eat\u00e9(e).",
        "job-board-message": "Vous \u00eates d\u00e9j\u00e0 candidat(e) pour ce poste. N'h\u00e9sitez pas \u00e0 explorer nos autres offres d'emploi.",
        "job-board-button": "Explorer les offres d'emploi"
      },
      "submit-page": {
        "required-fields": "(Tous les champs sont obligatoires, sauf indication contraire)",
        "email": "Email",
        "email-address": "Adresse email",
        "name": "Nom",
        "firstName": "Pr\u00e9nom",
        "lastName": "Nom de famille",
        "phone": "Num\u00e9ro de t\u00e9l\u00e9phone",
        "postal-code": "Code Postal",
        "homeLocation": "Adresse",
        "homeLocation-placeholder":"Entrez votre code postal",
        "homeLocation-placeholder-general-application": "Code Postal",
        "communication-preferences": {
          "label": "Pr\u00e9f\u00e9rences de communication",
          "copy": "Je souhaite recevoir des SMS pour cette candidature et d'autres opportunit\u00e9s similaires. Des frais peuvent s'appliquer."
        },
        "personal-info": "Informations personnelles",
        "edit-personal-info": "Pour modifier les donn\u00e9es personnelles, cliquez sur",
        "myaquent": "MyAquent",
        "welcome-back": "Bienvenue ! Votre profil est bien enregistré - mettez à jour vos dernières expériences",
        "all-fields-required": "(tous les champs sont obligatoires sauf indication contraire)",
        "terms": {
          "copy": "En soumettant votre candidature, vous cr\u00e9ez un compte MyAquent, votre espace personnel pour g\u00e9rer vos candidatures et pr\u00e9f\u00e9rences. Profitez de nos services de recherche d'emploi pour trouver de nouvelles opportunit\u00e9s.",
          "message": "En soumettant ce formulaire, vous vous inscrivez auprès d’Aquent en tant que Talent afin de bénéficier de services d’aide à la recherche d’emploi. Un compte est créé sur MyAquent, où vous pouvez gérer et mettre à jour vos candidatures et vos préférences",
          "agree": "Je comprends et j'accepte les",
          "terms-of-service": "Conditions d'utilisation d'Aquent",
          "communication-preferences": "J’accepte de recevoir des communications et des mises à jour par e-mail."
        },
        "optional": "facultatif",
        "professional-profile-placeholder": "URL du profil professionnel",
        "professional-profile-hint": "LinkedIn, Indeed, etc.",
        "portfolio-placeholder": "Website, Vimeo, Behance etc",
        "profiles-portfolios": "Profile et Portfolios",
        "optional-text": "optionnel",
        "profile": "Profil",
        "portfolio-work": "Portfolio & Réalisations",
        "add-profile": "Ajouter le profil",
        "add-portfolio": "Ajouter des réalisations",
        "password": "Mot de Passe",
        "resume": {
          "last-updated": "derni\u00e8re mise \u00e0 jour",
          "upload-text": "Soumettre un nouveau CV ici",
          "file-types": "(.pdf, .doc, .docx, .txt, .rtf, .html, .png, .jpg)",
          "button-browse": "Parcourir les fichiers",
          "button-update": "Mettre \u00e0 jour le CV",
          "update-existing-info": "Un nouveau CV mettra \u00e0 jour vos \u00e9tudes, comp\u00e9tences et exp\u00e9riences dans MyAquent",
          "invalid-file-type": "V\u00e9rifiez le type de fichier, taille maximale de 20 Mo"
        },
        "submit-application": "Soumettre la candidature",
        "update-profile": "Mettre à jour le profil",
        "submit-error-header": "Erreur de soumission",
        "submit-error-body": "Nous avons rencontr\u00e9 un probl\u00e8me lors du traitement de votre candidature. Veuillez envoyer un email en indiquant l'identifiant d'erreur #{{errorId}}",
        "submit-error-message-reference": "et la r\u00e9f\u00e9rence",
        "submit-error-message-id": "et la r\u00e9f\u00e9rence Error ID# {{errorId}}",
        "profile-url-invalid": "URL invalide"
      },
      "email-login-page": {
        "email": "Email ou nom d'utilisateur",
        "email-general-application": "Email",
        "email-username-invalid": "Veuillez fournir une adresse email ou un nom d'utilisateur valide.",
        "continue": "Continuer"
      },
      "otp-page": {
        "otp-header": "Saisissez le code de v\u00e9rification",
        "otp-helper-info": "Veuillez v\u00e9rifier votre email en entrant le code \u00e0 6 chiffres envoy\u00e9 \u00e0 {{email}}",
        "otp-code": "Code",
        "otp-resend-helper-info": "Vous n'avez pas re\u00e7u de code ?",
        "otp-resend": "Renvoyer",
        "otp-invalid": "Code invalide.",
        "password-invalid": "Mot de passe invalide",
        "sign-in-with-password": "Se connecter avec un mot de passe",
        "enter-password": "Saisissez votre mot de passe",
        "forgot-password": "Mot de passe oubli\u00e9 ?",
        "password": "Mot de passe",
        "max-attempts": "Limite de 3 tentatives d\u00e9pass\u00e9e.",
        "code-expired": "Le code a expir\u00e9."
      },
      "continue": "Continuer",
      "back": "Retour"
    },
    "job-posting-closed-page": {
      "no-longer-available": "Cette offre d'emploi n'est plus disponible.",
      "job-not-found": "L'offre d'emploi que vous recherchez n'est plus disponible.",
      "button": "Explorer plus d'offres d'emploi"
    },
    "country-names": {
      "1": "\u00c9tats-Unis",
      "2": "Canada",
      "3": "Irlande",
      "4": "Allemagne",
      "5": "France",
      "6": "Japon",
      "7": "Chine",
      "8": "Australie",
      "9": "Royaume-Uni",
      "10": "Pays-Bas",
      "11": "Singapour",
      "12": "Su\u00e8de",
      "13": "Nouvelle-Z\u00e9lande",
      "14": "Argentine",
      "15": "Autriche",
      "16": "Belgique",
      "17": "Bolivie",
      "18": "Br\u00e9sil",
      "19": "Chili",
      "20": "Colombie",
      "21": "Costa Rica",
      "22": "R\u00e9publique tch\u00e8que",
      "23": "Danemark",
      "24": "\u00c9quateur",
      "25": "Finlande",
      "26": "Gr\u00e8ce",
      "27": "Guatemala",
      "28": "Honduras",
      "29": "Hong Kong",
      "30": "Hongrie",
      "31": "Inde",
      "32": "Indon\u00e9sie",
      "33": "Isra\u00ebl",
      "34": "Italie",
      "35": "Cor\u00e9e",
      "36": "Luxembourg",
      "37": "Macao",
      "38": "Malaisie",
      "39": "Mexique",
      "40": "Monaco",
      "41": "Maroc",
      "42": "Nouvelle-Cal\u00e9donie",
      "43": "Norv\u00e8ge",
      "44": "Panama",
      "45": "Paraguay",
      "46": "P\u00e9rou",
      "47": "Philippines",
      "48": "Pologne",
      "49": "Portugal",
      "50": "Porto Rico",
      "51": "Russie",
      "52": "Slov\u00e9nie",
      "53": "Afrique du Sud",
      "54": "Espagne",
      "55": "Suisse",
      "56": "Ta\u00efwan",
      "57": "Tha\u00eflande",
      "58": "Turquie",
      "59": "Uruguay",
      "60": "Venezuela",
      "61": "Vietnam",
      "62": "\u00c9mirats arabes unis",
      "63": "Ukraine",
      "64": "Bulgarie",
      "65": "Cambodge",
      "66": "Bahre\u00efn",
      "67": "Kowe\u00eft",
      "68": "Liban",
      "69": "Qatar",
      "70": "Roumanie",
      "71": "Arabie Saoudite"
    }
  }
}
